import { Component, Input, OnInit } from '@angular/core';
import { NewsContentPageNoteSection } from 'src/app/model/section/news-content-page-note-section';

@Component({
  selector: 'app-news-content-page-note-section',
  templateUrl: './news-content-page-note-section.component.html',
  styleUrls: ['./news-content-page-note-section.component.scss']
})
export class NewsContentPageNoteSectionComponent implements OnInit {
  @Input() noteSections: NewsContentPageNoteSection[] = [];

  constructor() {}

  ngOnInit(): void {}
}
